import { ClickstreamPurchase } from '@chegg/commerce-utils/dist/types/utils/RioUtils/eventSchemas'
import { AppRouteCreators } from '../types/core'
import { EnumLiteralsOf } from '../types/helpers'

const PageNames = {
  dashboard: 'citations dash',
  bibliography: 'bibliography',
  search: 'search',
  searchResults: 'citation search results',
  form: 'citation form',
} as const

export const pageSubGroupMap = {
  eval: 'citation evaluation review',
  form: 'citation form',
  searchresults: 'citation search results',
  view: 'bibliography',
} as const
export interface DataLayerEvent {
  event: string
  purchase?: {
    id: string
    affiliation: string
    revenue: number
    shipping: number
    tax: number
    coupon: string
  }
  products?: Array<{
    id: string
    name: string
    brand: string
    category: string
    variant: string
    price: number
    quantity: number
    coupon: string
  }>
}

declare global {
  interface Window {
    dataLayer: any[]
  }
}

type PageName = EnumLiteralsOf<typeof PageNames>
type RouteToPageNameMap = Partial<Record<keyof AppRouteCreators, PageName>>

export const routeToPageNameMap: RouteToPageNameMap = {
  toCitationsDashboard: PageNames.dashboard,
  toCitationList: PageNames.bibliography,
  toCitationListSource: PageNames.search,
  toCitationListForm: PageNames.form,
} as const

export const getSubdomain = (hostname: string) => {
  const segments = hostname.split('.')
  const subdomain = segments.length < 3 ? 'www' : segments[0]
  return subdomain
}

export const sendToGTM = (data) => {
  if (typeof window !== 'undefined') {
    window.dataLayer = (window.dataLayer || []) as any[]
    window.dataLayer.push({
      ...data,
    })
  }
}

/**
 * Processes transaction pixel data and pushes it to Google Analytics dataLayer
 * @param purchaseDetails - The purchase details from the checkout callback
 */
export const processTransactionPixel = (
  purchaseDetails: ClickstreamPurchase | null
): void => {
  // Ensure dataLayer is initialized before use
  if (!window.dataLayer) {
    window.dataLayer = []
  }

  const dataLayerEvent: DataLayerEvent = {
    event: 'transaction',
    purchase: {
      id: purchaseDetails?.data?.transaction_id || '', // transaction ID is not available for trial purchases
      affiliation: purchaseDetails?.data?.transaction_id || '', // transaction ID is not available for trial purchases
      revenue: purchaseDetails?.data?.order?.total || 0,
      shipping: 0,
      tax: purchaseDetails?.data?.order?.tax_paid || 0,
      coupon: '',
    },
    products: [
      {
        id: purchaseDetails?.data?.products?.[0]?.product_id || '',
        name: 'Monthly Plus',
        brand: '',
        category: '',
        variant: '',
        price: purchaseDetails?.data?.order?.total || 0,
        quantity: purchaseDetails?.data?.products?.[0]?.quantity || 0,
        coupon: '',
      },
    ],
  }

  ;(window.dataLayer as any[]).push(dataLayerEvent)
}
